import { render, staticRenderFns } from "./FailGetCoupon.vue?vue&type=template&id=f57b2c04&"
import script from "./FailGetCoupon.vue?vue&type=script&lang=js&"
export * from "./FailGetCoupon.vue?vue&type=script&lang=js&"
import style0 from "./FailGetCoupon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports